import { Component, Suspense } from "react";
import AppManager from "../../../managers/AppManager";
import { COLUMN_CODE, TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import AutomationManager from "../AutomationManager";
import {
    DKLabel,
    DKSpinner,
    DKButton,
    INPUT_VIEW_DIRECTION,
    DKInput,
    DKCalendar
} from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import { PipelineManager } from "../../../managers/PipelineManager";
import { AUTOMATION_ACTIONS, AUTOMATION_TRIGGERS, AUTOMATION_TYPES, SPLIT_ACTION_TYPE, WORKFLOW_NODE_MAPPING } from "../AutomationConstants";
import FormatCurrencyService from "../../../services/FormatCurrencyService";
import AutomationService from "../../../services/automation";
import { DATE_FORMAT, FORMAT, INPUT_TYPE } from "../../../constants/Constant";
import Utility, { removeDelayedLoader, showDelayedLoader } from "../../../utility/Utility";
import Table from "../../../services/table";
import ic_info_blue from "../../../assets/icons/ic_info_blue.svg";
import moment from 'moment';
import calender from '../../../assets/icons/white/date_range.svg';
import { parseColumnConfig, parseVisibleColumnConfig } from "../../configs/config";

const KEY_CONST = {
    PIPELINE: "${Pipeline.",
    SYS_VAR: "${sys_var.",
    INVOICE_CREATED: "${Invoice Created."
};

let searchTimeout;

class CommissionReport extends Component {
    pipelines = [];
    columnData = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_COMMISSION_REPORT)), TABLES.PEOPLE_COMMISSION_REPORT)

    constructor(props) {
        super(props)
        this.state = {
            showLoader: true,
            automations: [],
            selectedAutomation: null,
            currentPage: 1,
            totalPageCount: 1,
            reportData: {
                columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_COMMISSION_REPORT)), TABLES.PEOPLE_COMMISSION_REPORT),
                rowData: [],
                originalData: [],
                filter: []
            },
            filters: [],
            datePeriod: {
                toggle: false,
                startDate: moment(moment().format()).startOf('month'),
                endDate: moment(moment().format()).endOf('month'),
                defaultDate: false
            }
        }
    }

    componentDidMount() {
        RouteManager.setPresenter(this);
        this.getPipelineData();
    }
    getPipelineData() {
        PipelineManager.get().then(
            () => {
                this.pipelines = PipelineManager.processPipelineData();
                this.populatePipelineAndStageOptions();
            }
        );
        this.getAutomations();
    }

    populatePipelineAndStageOptions() {
        if (this.columnData?.length > 0) {
            const columnPipeline = this.columnData.find((c) => c.columnCode === "dealPipeline");
            if (columnPipeline) {
                columnPipeline.options = this.pipelines;
            }
        }
    }

    getAutomations() {
        const params = {
            pageNo: 1,
            pageSize: 1000
        };

        Table.getRecordsByPage(params, null, TableManger.getTableId(TABLES.PEOPLE_AUTOMATION)).then(
            (response) => {
                if (response?.data?.length > 0) {
                    const workflowIdColumnId = TableManger.getColumnId(TABLES.PEOPLE_AUTOMATION, COLUMN_CODE.PEOPLE_AUTOMATION.WORKFLOW_ID);
                    const workflowNameColumnId = TableManger.getColumnId(TABLES.PEOPLE_AUTOMATION, COLUMN_CODE.PEOPLE_AUTOMATION.NAME);

                    const automations = [];
                    response.data.forEach((record) => {
                        if (AutomationManager.isCommissionType(record.cells)) {
                            automations.push({
                                id: record._id,
                                wId: record.cells[workflowIdColumnId],
                                name: record.cells[workflowNameColumnId]
                            });
                        }
                    });

                    this.setState({
                        automations: automations
                    }, () => {
                        if (!isNaN(parseInt(this.props.match.params.id))) {
                            this.setAutomation(parseInt(this.props.match.params.id));
                        } else {
                            this.setAutomation(automations[0]?.wId);
                        }
                    });
                } else {
                    this.setReportData([]);
                }
            }
        ).catch((error) => {});
    }

    setAutomation(automationId) {
        if (automationId) {
            this.setState({
                selectedAutomation: automationId
            }, () => {
                this.getAutomationReport();
            });
        }
    }

    getAutomationReport(searchStr) {
        const timer = showDelayedLoader();
        const automationId = this.state.selectedAutomation;
        if (automationId) {
            const params = this.getParams(searchStr);
            AutomationService.getAutomationReport(automationId, params).then(response => {
                removeDelayedLoader(timer);
                if (response?.data) {
                    const rowData = this.getRowData(response.data);
                    this.setReportData(rowData, response["page"], response["total_pages"]);
                } else {
                    this.setReportData([]);
                }
            }, error => {
                removeDelayedLoader(timer);
                console.log(error);
            });
        }
    }

    getParams(searchStr) {
        const params = {
            limit: 20,
            currentPage: this.state.currentPage,
        }

        if (this.state.datePeriod.startDate && this.state.datePeriod.endDate) {
            params["startDate"] = moment(this.state.datePeriod.startDate).format(FORMAT.YYYYMMDD);
            params["endDate"] = moment(this.state.datePeriod.endDate).format(FORMAT.YYYYMMDD);
        }

        if (this.state.filters?.length > 0) {
            params["filters"] = this.getFilterString(this.state.filters);
        }

        if (searchStr) {
            params["searchStr"] = searchStr;
        }

        return params;
    }

    getFilterString(filters) {
        const f = [];
        filters.forEach((filter) => {
            const column = this.state.reportData.columnData.find((c) => c.id === filter.key);
            if (column) {
                f.push({
                    condition: filter.condition,
                    key: column.columnCode,
                    value: Array.isArray(filter.value) ? filter.value.join(",") : filter.value
                });
            }
        });

        return JSON.stringify(f);
    }

    parseKey(key) {
        let VAR = null;

        if (key) {
            if (key.includes(KEY_CONST.PIPELINE)) {
                VAR = KEY_CONST.PIPELINE;
            } else if (key.includes(KEY_CONST.SYS_VAR)) {
                VAR = KEY_CONST.SYS_VAR;
            } else if (key.startsWith(KEY_CONST.INVOICE_CREATED)) {
                VAR = KEY_CONST.INVOICE_CREATED;
            }
    
            if (VAR) {
                return key.substring(key.indexOf(VAR) + VAR.length, key.length - 1);
            }
        }
    }

    parseVariables(variablesString) {
        let variables = null;

        if (variablesString) {
            try {
                variables = {};
                Object.entries(JSON.parse(variablesString)).forEach(([key, value]) => {
                    const parsedKey = this.parseKey(key);
                    if (parsedKey) {
                        variables[parsedKey] = value;
                    }
                });
            } catch {}
        }

        return variables;
    }

    parseWFGraph(wfGraphString) {
        let wfGraph = null;

        try {
            wfGraph = JSON.parse(wfGraphString);
        } catch {}

        return wfGraph;
    }

    getStep(steps, nodeExecId) {
        if (steps?.length > 0) {
            return steps.find((s) => s.id === nodeExecId);
        }
    }

    getRowData(reportData) {
        const rowData = [];
        const wfExecutionData = reportData?.wf_executed?.length > 0 ? reportData.wf_executed : [];

        wfExecutionData.forEach((wf) => {
            const row = {
                executionStart: Utility.formatDate(wf.processing_start_at, DATE_FORMAT.YYYYMMDD),
                executionEnd: Utility.formatDate(wf.processing_end_at, DATE_FORMAT.YYYYMMDD),
                executionTime: wf.exec_time ? String(wf.exec_time).concat("ms") : "",
            };

            const wfGraph = this.parseWFGraph(wf.workflow_graph);
            for (let index = 0; index < wfGraph.graphNodes.length; index++) {
                const step = wfGraph.graphNodes[index];
                const node = wf.node_executed.find((n) => n.node_executed_id === step.id);

                if (node) {
                    node["variables"] = this.parseVariables(node.variables);
                }

                const config = {
                    nodeType: step.node_type,
                    name: step.name,
                    original: {},
                    source: {},
                    result: !node ? -1 : 0
                };

                if (step) {
                    const { node_type, fields } = step;
                    switch (node_type) {
                        case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON]:
                            const pipelineColumn = TableManger.getColumnById(TABLES.DEAL, TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.PIPELINE_ID));
                            const stageColumn = TableManger.getColumnById(TABLES.DEAL, TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.STAGE_ID));
                            this.populatePipelineAndStageData(config, fields, node?.variables, pipelineColumn, stageColumn);

                            row["dealName"] = config.source["Deal Name"];
                            row["dealPipeline"] = config.source["Pipeline"];
                            row["dealStage"] = config.source["Stage"];
                            row["dealOwner"] = config.source["Deal Owner"];
                            break;
                        case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_INVOICE_CREATED]:
                            this.populateInvoiceCreateData(config, fields, node?.variables);
                            row["dealName"] = config.source["Invoice Code"];
                            row["dealOwner"] = config.source["Created By"];
                            break;
                        case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.SPLIT_WORKFLOW]:
                            this.populateSplitWorkFlowData(config, fields, node?.variables);

                            if (node) {
                                row["designation"] = config.source["Designation"];
                            }
                            break;
                        case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.DESIGNATION]:
                            this.populateDesignationData(config, fields, node?.variables);
                            
                            if (node) {
                                row["designation"] = config.source["Designation"];
                            }
                            break;
                        case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.CALCULATE_COMMISSION]:
                            this.populateCommissionData(config, fields, node?.variables);

                            if (node) {
                                row["dealAmount"] = config.source["Total Amount"];
                                row["commissionType"] = config.original["Commission Type"];
                                row["commissionValue"] = config.original["Commission Value"];
                                row["commissionAmount"] = config.source["Commission Amount"];
                            }
                            break;
                        case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.INVOICE_COMMISSION]:
                            this.populateInvoiceCommissionData(config, fields, node?.variables);

                            if (node) {
                                row["dealAmount"] = config.source["Total Amount"];
                                row["commissionType"] = config.original["Commission Type"];
                                row["commissionValue"] = config.original["Commission Value"];
                                row["commissionAmount"] = config.source["Commission Amount"];
                            }
                            break;
                    }
                }
            }

            rowData.push(row);
        });

        return rowData
    }

    getDisplayData(config, step, node) {
        if (step) {
            this.populateStepConfig(config, step, node);
        }

        this.populateStepExepectedResult(config);

        return this.buildStepData(config);
    }

    populateStepExepectedResult(config) {
        switch (config.nodeType) {
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON]:
                if (config.original["Pipeline"] === config.source["Pipeline"] && config.original["Stage"] === config.source["Stage"]) {
                    config["result"] = 1;
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.SPLIT_WORKFLOW]:
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.DESIGNATION]:
                if (config.original["Designation"]?.split(", ")?.length > 0) {
                    config.original["Designation"].split(", ").forEach((designation) => {
                        if (designation === config.source["Designation"]) {
                            config["result"] = 1;
                        }
                    });
                }
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.CALCULATE_COMMISSION]:
                if (config.source["Commission Amount"] !== "-") {
                    config["result"] = 1;
                }
                break;
        }
    }

    buildStepData(config) {
        return (
            `<div class="column">
                <div class="row mb-s">
                    <span class="fw-m">Step Name: </span>
                    <span>${config.name}</span>
                </div>
                <div class="column mb-s">
                    <div class="row">
                        <span class="fw-m">Automation Data:</span>
                    </div>
                    <ul class="column m-0">
                        ${
                            Object.entries(config.original).map(([key, value]) => {
                                return `<li>${key}: ${value}</li>`;
                            }).join("")
                        }
                    </ul>
                </div>
                <div class="column mb-s">
                    <div class="row">
                        <span class="fw-m">Source Data:</span>
                    </div>
                    <ul class="column m-0">
                        ${
                            Object.entries(config.source).map(([key, value]) => {
                                return `<li>${key}: ${value}</li>`;
                            }).join("")
                        }
                    </ul>
                </div>
                <div class="row">
                    <span class="fw-m">Execution Result: </span>
                    <span>${this.getExecutionResultText(config.result)}</span>
                </div>
            </div>`
        );
    }

    getExecutionResultText(result) {
        switch (result) {
            case 1:
                return "<span class='fw-m text-app'>Success</span>";
            case 0:
                return "<span class='fw-m text-red'>Failure</span>";
            case -1:
                return "<span class='fw-m'>Not Executed</span>";
        }
    }

    populateStepConfig(config, step, node) {
        const { node_type, fields } = step;

        switch (node_type) {
            case WORKFLOW_NODE_MAPPING[AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON]:
                const pipelineColumn = TableManger.getColumnById(TABLES.DEAL, TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.PIPELINE_ID));
                const stageColumn = TableManger.getColumnById(TABLES.DEAL, TableManger.getColumnId(TABLES.DEAL, COLUMN_CODE.DEAL.STAGE_ID));
                this.populatePipelineAndStageData(config, fields, node?.variables, pipelineColumn, stageColumn);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.SPLIT_WORKFLOW]:
                this.populateSplitWorkFlowData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.CALCULATE_COMMISSION]:
                this.populateCommissionData(config, fields, node?.variables);
                break;
            case WORKFLOW_NODE_MAPPING[AUTOMATION_ACTIONS.INVOICE_COMMISSION]:
                this.populateInvoiceCommissionData(config, fields, node?.variables);
                break;
        }
    }

    populatePipelineAndStageData(config, fields, variables, pipelineColumn, stageColumn) {
        let originalStages;
        let sourceStages;

        config.source["Deal Name"] = variables?.name || "-";
        config.source["Deal Owner"] = this.getUserName(variables?.user?.firstName, variables?.user?.lastName) || "-";

        if (pipelineColumn) {
            const field = fields.find((f) => f.code === pipelineColumn.key);
            this.pipelines.forEach((o) => {
                if (o.id === field.value) {
                    originalStages = o.stages;
                    config.original["Pipeline"] = o.name;
                }

                if (o.id === variables?.pipelineId) {
                    sourceStages = o.stages;
                    config.source["Pipeline"] = o.name;
                }
            });
        }

        if (stageColumn) {
            const field = fields.find((f) => f.code === stageColumn.key);

            originalStages?.forEach((o) => {
                if (o.id === field.value) {
                    config.original["Stage"] = o.name;
                }
            });

            sourceStages?.forEach((o) => {
                if (o.id === variables?.stageId) {
                    config.source["Stage"] = o.name;
                }
            });
        }
    }

    getUserName(firstName, lastName) {
        firstName = firstName || "";
        lastName = lastName || "";

        return String().concat(firstName, " ", lastName);
    }

    populateInvoiceCreateData(config, fields, variables) {
        config.original["Trigger"] = "Create Invoice";
        config.source["Invoice Code"] = variables?.name || "";
        config.source["Created By"] = this.getUserName(variables?.user?.firstName, variables?.user?.lastName) || "-";
    }

    populateSplitWorkFlowData(config, fields, variables) {
        fields?.forEach((field) => {
            switch (field.field_type) {
                case WORKFLOW_NODE_MAPPING[SPLIT_ACTION_TYPE.DESIGNATION_CHECK]:
                    const designation = [];
                    field?.conditions.forEach((c) => {
                        if (c.code === "designation") {
                            designation.push(c.value);
                        }
                    });
                    config.original["Designation"] = designation.join(", ");
                    config.source["Designation"] = variables?.user?.designation ? variables?.user?.designation : "-";
                    break;
            }
        });
    }

    populateDesignationData(config, fields, variables) {
        fields?.forEach((field) => {
            switch (field.app_node_code) {
                case WORKFLOW_NODE_MAPPING[SPLIT_ACTION_TYPE.DESIGNATION]:
                    if (field.code === "designation") {
                        const designation = [];
                        designation.push(field.value);
                        config.original["Designation"] = designation.join(", ");
                        config.source["Designation"] = variables?.user?.designation ? variables?.user?.designation : "-";
                    }
                    break;
            }
        });
    }

    populateCommissionData(config, fields, variables) {
        let commissionType;
        let commissionValue;

        fields?.some((field) => {
            commissionType = field.code;
            commissionValue = field.value;
        });

        if (commissionType === "flatAmount") {
            config.original["Commission Type"] = "Flat";
            config.original["Commission Value"] = commissionValue ? FormatCurrencyService.format(commissionValue) : "-";
        } else if (commissionType === "percentageOfDealCost") {
            config.original["Commission Type"] = "Percentage of Total Amount";
            config.original["Commission Value"] = `${commissionValue}%`;
        }

        config.source["Total Amount"] = variables?.amount ? FormatCurrencyService.format(variables?.amount) : "-";
        config.source["Commission Amount"] = variables?.commissionAmount ? this.getCommissionAmount(variables?.amount, variables?.commissionAmount, commissionType, commissionValue) : "-";
    }

    populateInvoiceCommissionData(config, fields, variables) {
        let commissionType;
        let commissionValue;

        for (let field of fields) {
            switch (field.code) {
                case "invoiceAmount":
                    const entries = field.value?.split(",");
                    if (Array.isArray(entries) && variables?.amount >= entries[0] && variables?.amount <= entries[1]) {
                        commissionValue = entries[2];
                        commissionType = entries[3];
                    }
                    break;
                default:
                    break;
            }

            if (commissionType) {
                break;
            }
        }

        if (commissionType === "flatAmount") {
            config.original["Commission Type"] = "Flat";
            config.original["Commission Value"] = commissionValue ? FormatCurrencyService.format(commissionValue) : "-";
        } else if (commissionType === "percentageOfDealCost") {
            config.original["Commission Type"] = "Percentage of Total Amount";
            config.original["Commission Value"] = `${commissionValue}%`;
        }

        config.source["Total Amount"] = variables?.amount ? FormatCurrencyService.format(variables?.amount) : "-";
        config.source["Commission Amount"] = variables?.commissionAmount ? this.getCommissionAmount(variables?.amount, variables?.commissionAmount, commissionType, commissionValue) : "-";
    }

    getCommissionAmount(totalAmount, commissionAmount, commissionType, commissionValue) {
        return (
            `<div class="d-flex align-items-center">
                <div>${FormatCurrencyService.format(commissionAmount)}</div>
                <div class="d-flex ml-xs" data-tip="${this.getCommissonTooltipText(totalAmount, commissionAmount, commissionType, commissionValue)}">
                    <img class="ic-s" src= ${ic_info_blue} />
                </div>
            </div>`
        )
    }

    getCommissonTooltipText(totalAmount, commissionAmount, commissionType, commissionValue) {
        let tooltip = ``;

        if (commissionType === "flatAmount") {
            tooltip = `Flat Commission of ${FormatCurrencyService.format(commissionValue)}`;
        } else if (commissionType === "percentageOfDealCost") {
            tooltip = `${commissionValue}% of ${FormatCurrencyService.format(totalAmount)} = ${FormatCurrencyService.format(commissionAmount)}`;
        }

        return tooltip;
    }

    setReportData(rowData, currentPage, totalPageCount) {
        this.setState({
            currentPage: currentPage || this.state.currentPage,
            totalPageCount: totalPageCount || this.state.totalPageCount,
            reportData: {
                columnData: this.columnData,
                rowData: rowData,
                originalData: rowData,
                filter: this.state.filters
            }
        });
    }

    getAutomationName(id) {
        const automation = this.state.automations.find((a) => a.wId === id);
        return automation ? automation.name : "";
    }

    onFilter() {
        this.getAutomationReport();
    }

    onSearch(searchStr) {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            this.getAutomationReport(searchStr);
        }, 250);
    }

    getDatePeriodText(startDate, endDate) {
        if (startDate && endDate) {
            return `${Utility.formatDate(moment(startDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment(endDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`;
        }

        return `${Utility.formatDate(moment().startOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment().endOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`;
    }

    reloadGridDataAndColumn() {
        this.columnData = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_COMMISSION_REPORT)), TABLES.PEOPLE_COMMISSION_REPORT)
        this.setState({              
            ...this.state,               
            reportData: {   
                ...this.state.reportData,                                
                columnData: this.columnData
            }
        },()=>{     
            this.getPipelineData();
        })
    }
    renderBody() {
        return (
            <div className="column parent-width flex-1">
                <div className="row justify-content-start">
                    <div className="column">
                        <DKLabel text={"Commission Report of "} className="fw-m fs-l" />
                    </div>
                    <div className="column mr-s" style={{ zIndex: 4, width: "230px" }}>
                        <DKInput
                            type={INPUT_TYPE.DROPDOWN}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            dropdownConfig={{
                                allowSearch: this.state.automations.length > 7,
                                data: this.state.automations,
                                renderer: (i, item) => item.name,
                                onSelect: (i, value) => {
                                    this.setState({
                                        currentPage: 1
                                    }, () => {
                                        this.setAutomation(value?.wId);
                                    });
                                }
                            }}
                            value={this.getAutomationName(this.state.selectedAutomation)}
                            onChange={() => {}}
                        />
                    </div>
                    <div className="column" style={{ zIndex: 99 }}>
                        <DKButton
                            className="bg-app text-white"
                            title={this.getDatePeriodText(this.state.datePeriod.startDate, this.state.datePeriod.endDate)}
                            icon={calender}
                            onClick={(value) => {
                                this.setState({
                                    datePeriod: {
                                        toggle: !this.state.datePeriod.toggle,
                                        startDate: this.state.datePeriod.startDate,
                                        endDate: this.state.datePeriod.endDate,
                                        defaultDate: true
                                    }
                                });
                            }}
                        />
                        {this.state.datePeriod.toggle && (
                            <DKCalendar
                                className="position-absolute border-m shadow-m bg-white z-index-1 mt-s"
                                isDateRange={true}
                                startDate={this.state.datePeriod.startDate ? new Date(this.state.datePeriod.startDate) : new Date()}
                                endDate={this.state.datePeriod.endDate ? new Date(this.state.datePeriod.endDate) : new Date()}
                                onSelectDate={(startDate, endDate) => {
                                    if (startDate && endDate) {
                                        this.setState({
                                            datePeriod: {
                                                toggle: false,
                                                startDate: startDate,
                                                endDate: endDate,
                                                defaultDate: false
                                            }
                                        }, () => {
                                            this.getAutomationReport();
                                        });
                                    }
                                }}
                                onClose={() => {
                                    this.setState({
                                        datePeriod: {
                                            toggle: false,
                                            startDate: this.state.datePeriod.startDate,
                                            endDate: this.state.datePeriod.endDate,
                                            defaultDate: false
                                        }
                                    });
                                }}
                            />
                        )}
                    </div>
                </div>
                <div className="column" style={{ marginTop: "-43px", height: "70%" }}>
                    <div className="flex-1 position-relative" style={{ minHeight: "200px" }}>
                        <Suspense
                            fallback={
                                <div className="row justify-content-center">
                                    <DKSpinner />
                                </div>
                            }
                        >
                            <DataGridHolderPayroll
                                tableName={TABLES.PEOPLE_COMMISSION_REPORT}
                                displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_COMMISSION_REPORT]}
                                allowColumnEdit={false}
                                allowColumnDelete={false}
                                allowColumnShift={false}
                                allowSearch={true}
                                allowFilter={true}
                                allowColumnAdd={false}
                                allowDataExport={false}
                                allowExpand={false}
                                gridData={this.state.reportData}
                                currentPage={this.state.currentPage}
                                totalPageCount={this.state.totalPageCount}
                                allowRowEdit={false}
                                filter={this.state.filters}
                                onPaginationClick={(requestedPageNumber) => {
                                    this.setState({
                                        currentPage: requestedPageNumber
                                    }, () => {
                                        this.getAutomationReport();
                                    });
                                }}
                                onFilter={(dataList, queries) => {
                                    this.onFilter();
                                }}
                                onSearch={(searchStr) => {
                                    this.onSearch(searchStr);
                                }}
                                onColumnShift={(data)=>{
                                    this.reloadGridDataAndColumn()
                                }}
                            />
                        </Suspense>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return this.renderBody()
    }
}

export default CommissionReport;
